// in order for the same assets to compile once and work correctly in staging
// and production, we need to change the public path (which is prefixed to
// URLs referenced from other assets, i.e. inside JS or CSS included by the
// packs) "on the fly": https://webpack.js.org/guides/public-path/#on-the-fly
// See also:
//   https://github.com/rails/webpacker/issues/2269#issuecomment-548816104
__webpack_public_path__ = window.__webpack_public_path__;
